<template>
  <div class="dimed wrap" style="z-index: 7">
    <div class="layer">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('Modal.PaymentError.msg1') }}</div>
        <div class="ft-error">{{ $t('Modal.PaymentError.msg2') }}</div>
        <div class="lyr-txt">{{ $t('Modal.PaymentError.msg3') }}</div>
      </div>
      <div class="layer__body">
        <div class="info-area">
          <span class="img-error yellow"></span>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--line btn--xlg btn-anim" @mouseup="$emit('closeModal')">{{ $t('Modal.PaymentError.msg4') }}</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'paymentError',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
    };
  },
  mounted() {},
  props: {},
  methods: {},
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped></style>
